<ion-card class="card-common-blue ion-no-margin ion-margin-top">

  <!-- Card header with optional category title or back navigation title -->
  <ion-card-header class="cursor-pointer" (click)="emitHeaderClick()">

    <!-- Category title when available -->
    @if(item()?.categorY_TITLE)
    {
    <ion-card-title>
      <span>
        {{ item()?.categorY_TITLE }}
      </span>
    </ion-card-title>
    }

    <!-- Back navigation style title when category title is null and parent title exists -->
    @if(item()?.categorY_TITLE == null && title())
    {
    <ion-card-title class="cursor-pointer">
      <ion-icon src=" assets/imgs/left-chevron.svg" class="iconPadding font24"></ion-icon>
      <span class="ion-margin-start">{{title() }}</span>
    </ion-card-title>
    }

  </ion-card-header>

  <ion-card-content class="ion-margin-top">

    <!-- Category or fallback description section -->
    @if(item()?.categorY_DESCRIPTION || description() )
    {
    <ion-row>
      <ion-col>
        <ion-label class="primary-color font-md">
          {{item()?.categorY_DESCRIPTION ?? description() }}
        </ion-label>
      </ion-col>
    </ion-row>
    }

    <!-- Service list rendered from grouped catalog items -->
    <ion-list lines="none" class="custom-list ion-no-padding">
      @for (data of item()?.items; track $index) {
      <ng-container>

        <!-- Render only bookable follow-on services -->
        @if(data.folloW_ON_CANNOT_BOOK != 1)
        {
        <ion-item class="cursor-pointer" (click)="getServiceCatalog(data.servicE_CATALOG_ID)">
          <ion-label class="labelColor">
            <a class="text-decoration-none">
              {{data.sC_SERVICE_TITLE}}
            </a>
          </ion-label>

          <ion-icon src="assets/imgs/chevron-right.svg"></ion-icon>
        </ion-item>
        }

      </ng-container>
      }
    </ion-list>

  </ion-card-content>

</ion-card>